// extracted by mini-css-extract-plugin
module.exports = {"border-bottom-transparent":"styles-module__border-bottom-transparent___iUoMH","border-bottom-dark-primary":"styles-module__border-bottom-dark-primary___cOL40"};